import React, { useEffect, useState, useRef } from "react";

import {
  CButton,
  CCol,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle /* CRow */
} from "@coreui/react";
import isUrl from "is-url";
import { useSelector } from "react-redux";
import { Button } from "reactstrap";
import { useEditor } from "slate-react";

import URL$1 from "../../../../config/api";
import axios from "../../../../config/axios";
import Criarte from "../criarte";

import "./styles.css";

const TextEditorInsertingModal = props => {
  const editor = useEditor();
  const inputRef = useRef();
  const [imageSrc, setImageSrc] = useState(undefined);
  const [imageUrlChecker, setImageUrlChecker] = useState("null");
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageName, setImageName] = useState(undefined);
  const user = useSelector(state => state.user);
  const [literarteShow, setLiterarteShow] = useState(false);
  const [importShow, setImportShow] = useState(false);
  const [gallery, setGallery] = useState([]);

  useEffect(() => {
    updateGallery();
  }, []);

  const updateGallery = () => {
    let obj = {
      user_id: user.user.id
    };
    axios
      .post(`${URL$1.api}gallery/list`, obj, {
        headers: { authorization: `Bearer ${user.token}` }
      })
      .then(resp => {
        if (resp.data.success) {
          let galleryAux = [];
          resp.data.data.forEach(image => {
            galleryAux.push({
              id: image.id,
              user_id: image.user_id,
              path: image.path,
              name: image.name,
              isSelected: false
            });
          });
          setGallery(galleryAux);
        }
      });
  };

  const changeSelectedImage = selectedImage => {
    const file = new FormData();
    file.append("filepond", selectedImage);

    axios
      .post(`${URL$1.api}file/gallery/${user.user.id}`, file, {
        headers: {
          authorization: `Bearer ${user.token}`,
          "Content-Type": "multipart/form-data"
        }
      })
      .then(resp => {
        if (resp.data.success) {
          setImageSrc(URL$1.public + resp.data.data.url);
          setSelectedImage(selectedImage);
          setImageName(resp.data.name);
        }
      });
  };

  const checkUrl = url => {
    isUrl(url) ? setImageUrlChecker(true) : setImageUrlChecker(false);
  };

  const deleteImage = () => {
    const imageToDelete = {
      name: imageName
    };

    axios
      .post(
        `${URL$1.api}removeFile/question_images/${user.user.id}`,
        imageToDelete,
        { headers: { authorization: `Bearer ${user.token}` } }
      )
      .then(resp => {
        if (resp.data.success) {
          setImageName(undefined);
        }
      });
  };

  const cancelImageImporterModal = () => {
    if (!imageSrc && !selectedImage) return props.hideImageImporter();
    if (
      window.confirm(
        "Se você sair agora não enviará sua imagem. Deseja cancelar mesmo assim?"
      )
    ) {
      setImageSrc(undefined);
      setSelectedImage(null);
      setImageUrlChecker("null");
      setImportShow(false);
      props.hideImageImporter();
      deleteImage();
    }
  };

  const closeLiterarte = () => {
    setLiterarteShow(false);
  };

  const selectImage = image => {
    let galleryAux = [];
    gallery.forEach(imageList => {
      if (image.id === imageList.id) {
        imageList.isSelected = true;
      } else {
        imageList.isSelected = false;
      }
      galleryAux.push(imageList);
    });
    setImageSrc(URL$1.public + image.path + image.name);
    setGallery(galleryAux);
  };

  return (
    <CModal
      show={props.show}
      onClose={() => cancelImageImporterModal()}
      size="lg w-100 h-100 m-0 p-2 mw-100"
      style={{ width: "100%", height: "100%" }}
      closeOnBackdrop={false}
    >
      <CModalHeader closeButton>
        <CModalTitle>Imagem</CModalTitle>
      </CModalHeader>
      <CModalBody
        className="p-0 d-flex"
        style={{
          overflow: "auto",
          backgroundColor: literarteShow ? "#e5e5e5" : ""
        }}
      >
        {literarteShow ? (
          <Criarte
            saveImage={obj => {
              props.insertImage(editor, URL$1.public + obj.path + obj.name);
              cancelImageImporterModal();
              updateGallery();
              setLiterarteShow(false);
            }}
            closeLiterarte={() => closeLiterarte()}
          />
        ) : importShow ? (
          <CCol lg="12">
            <Button
              style={{ width: "100%", marginTop: "10px" }}
              onClick={() => setLiterarteShow(true)}
            >
              Criarte
            </Button>
            <h5 className="mb-3">Ou importe uma imagem:</h5>
            <section className="local-image-importer">
              <input
                type="file"
                accept="image/jpg, image/png"
                hidden
                ref={inputRef}
                onChange={e => changeSelectedImage(e.target.files[0])}
              />
              {selectedImage === null ? (
                <button
                  onClick={() => {
                    inputRef.current.click();
                  }}
                  className="local-image-importer-button"
                >
                  Importar Imagem
                </button>
              ) : (
                <img src={imageSrc} alt="" className="locally-imported-image" />
              )}
            </section>
            <h5 className="mb-3">Galeria:</h5>
            <div style={{ display: "flex", flexDirection: "row" }}>
              {gallery.map(image => (
                <img
                  key={image.id}
                  style={{
                    maxWidth: "100px",
                    border: "1px solid black",
                    cursor: "pointer",
                    marginRight: "10px",
                    backgroundColor: image.isSelected
                      ? "rgba(91, 129, 225, 0.49)"
                      : ""
                  }}
                  src={URL$1.public + image.path + image.name}
                  onClick={() => selectImage(image)}
                />
              ))}
            </div>
            <div className="image-importer-submit-menu">
              <button
                onClick={() => cancelImageImporterModal()}
                className="cancel-image-importer-button"
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="btn submit-image-importer-button"
                disabled={!imageSrc}
                onMouseDown={e => {
                  e.preventDefault();
                  if (!imageSrc) return;
                  props.insertImage(editor, imageSrc);
                  setImageSrc(undefined);
                  setSelectedImage(null);
                  setImportShow(false);
                  setImageUrlChecker("null");
                  props.hideImageImporter();
                  updateGallery();
                }}
              >
                Confirmar
              </button>
            </div>
          </CCol>
        ) : (
          <CCol lg="12" className="py-3 d-flex flex-column">
            <h5 className="mb-3">Crie uma nova arte</h5>
            <CButton
              color="primary"
              className="align-self-start"
              onClick={() => setLiterarteShow(true)}
            >
              Criarte
            </CButton>
            <h5 className="my-3">Ou importe uma imagem</h5>
            <section className="local-image-importer">
              <input
                type="file"
                accept="image/jpg, image/png"
                hidden
                ref={inputRef}
                onChange={e => changeSelectedImage(e.target.files[0])}
              />
              {selectedImage === null ? (
                <button
                  onClick={() => {
                    inputRef.current.click();
                  }}
                  className="local-image-importer-button"
                >
                  Importar Imagem
                </button>
              ) : (
                <img src={imageSrc} alt="" className="locally-imported-image" />
              )}
            </section>
            <h5 className="mb-3">Galeria</h5>
            <div className="flex-1 overflow-auto">
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(12, 1fr)",
                  gridGap: "10px"
                }}
              >
                {gallery.map(image => (
                  <div
                    key={image.id}
                    style={{
                      position: "relative",
                      overflow: "hidden",
                      paddingBottom: "100%"
                    }}
                  >
                    <img
                      className="w-100 h-100"
                      style={{
                        position: "absolute",
                        objectFit: "contain",
                        borderRadius: "0.25rem",
                        cursor: "pointer"
                      }}
                      src={URL$1.public + image.path + image.name.toLowerCase()}
                    />
                    <div
                      className="w-100 h-100"
                      style={{
                        position: "absolute",
                        zIndex: 100,
                        border: "1px solid #d8dbe0",
                        transition: "0.15s ease-in-out",
                        borderRadius: "0.25rem",
                        cursor: "pointer",
                        backgroundColor: image.isSelected
                          ? "rgba(91, 129, 225, 0.49)"
                          : ""
                      }}
                      onClick={() => selectImage(image)}
                    />
                  </div>
                ))}
              </div>
            </div>
            <div className="image-importer-submit-menu">
              <button
                onClick={() => cancelImageImporterModal()}
                className="cancel-image-importer-button"
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="btn submit-image-importer-button"
                disabled={!imageSrc}
                onMouseDown={e => {
                  e.preventDefault();
                  if (!imageSrc) return;
                  props.insertImage(editor, imageSrc);
                  setImageSrc(undefined);
                  setSelectedImage(null);
                  setImportShow(false);
                  setImageUrlChecker("null");
                  props.hideImageImporter();
                  updateGallery();
                }}
              >
                Confirmar
              </button>
            </div>
          </CCol>
        )}
      </CModalBody>
    </CModal>
  );
};

export default TextEditorInsertingModal;
